import script from "./Podcasts.vue?vue&type=script&setup=true&lang=ts"
export * from "./Podcasts.vue?vue&type=script&setup=true&lang=ts"

import "./Podcasts.vue?vue&type=style&index=0&id=5693dd17&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5693dd17"]])

export default __exports__